import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

import api from "../../../utils/api";
import axiosInstance from "../../../utils/axiosConfig";
import { RootState } from "../../rootReducer";

export const findUserRoleCode = createAsyncThunk(
    "userTemplate/findUserRoleCode",
    async (id: string, { rejectWithValue, getState }) => {
        const state = getState() as RootState;
        try {
            const { data } = await axiosInstance.get(`${api.baseURL}userrole`, {
                params: {
                    populate: false,
                    where: {
                        user: id,
                        enabled: true,
                        sourceOrganization: state.userAuthentication.user?.sourceOrganization,
                    },
                },
            })
            if (data.length > 0) {
                return data[0].code;
            }
            return "";
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);










